// extracted by mini-css-extract-plugin
export var labelWrapper = "_m3-0";